import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { LibraryModalService } from '@app/library/services/library-modal.service';
import { TrashState } from '@app/library/states/trash.state';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-trash-header',
  templateUrl: './trash-header.component.html',
  styleUrls: ['./trash-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrashHeaderComponent {
  @Select(TrashState.archivedTracksLength)
  archivedTracksLength$: Observable<number>;

  @Input()
  displayedArchivedTracksLength: number;

  @Output()
  readonly changeSearch = new EventEmitter();

  currentSearchValue: string;

  constructor(
    private readonly store: Store,
    private readonly modalService: LibraryModalService,
  ) {}

  emptyTrash() {
    this.modalService.deleteMultipleArchivedTracks(
      this.store.selectSnapshot(TrashState.archivedTracks).map(({ id }) => id),
      true,
    );
  }

  editSearch(e: string) {
    if (typeof e === 'string') {
      this.currentSearchValue = e;
      this.changeSearch.emit(e);
    }
  }
}
